var _circle, _path, _circle2, _path2, _circle3, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNotSuitableForChildren = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 30 30"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 21.458,
  cy: 9.083,
  r: 2.833,
  stroke: "#77838D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#77838D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "m19.864 23.25.177 1.417h2.834l.708-5.666H25v-2.125a3.542 3.542 0 0 0-5.667-2.834"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 7.291,
  cy: 9.083,
  r: 2.833,
  stroke: "#77838D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#77838D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "m8.886 23.25-.178 1.417H5.875l-.708-5.666H3.75v-2.125a3.542 3.542 0 0 1 5.667-2.834"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 14.375,
  cy: 12.625,
  r: 2.125,
  stroke: "#77838D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#77838D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M14.375 16.166a3.54 3.54 0 0 0-3.542 3.542v.708h1.417l.708 4.25h1.417M14.375 16.166a3.54 3.54 0 0 1 3.542 3.542v.708H16.5l-.708 4.25h-1.417"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#77838D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  clipPath: "url(#notSuitableForChildren_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.935 15a14.062 14.062 0 1 0 28.125 0A14.062 14.062 0 0 0 .935 15M5.054 24.944 24.94 5.057"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "notSuitableForChildren_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h30v30H0z"
})))));
export default SvgNotSuitableForChildren;